<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon>
          </v-btn>
          <span>Edit Maintenance Log</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-autocomplete
                ref="device"
                outlined
                v-model="form.device_id"
                :items="deviceItems"
                label="Device"
                prepend-inner-icon="mdi-desktop-tower"
                clearable
                :error-messages="errors.device_id"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                ref="technician"
                outlined
                v-model="form.technician_id"
                :items="technicianItems"
                label="Technician"
                prepend-inner-icon="mdi-account-wrench"
                clearable
                :error-messages="errors.technician_id"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-select
                v-model="form.log_type"
                outlined
                :items="logTypeItems"
                label="Log Type *"
                prepend-inner-icon="mdi-clipboard-text"
                :error-messages="errors.log_type"
              ></v-select>
            </v-col>
            <v-col sm="12">
              <v-textarea
                v-model="form.description"
                outlined
                label="Description"
                prepend-inner-icon="mdi-text"
                rows="4"
                :error-messages="errors.description"
              ></v-textarea>
            </v-col>
            <v-col sm="4">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_active"
                inset
                :label="`Is Active: ${form.is_active ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
          </v-row>
          <v-btn
            :loading="isLoading"
            :disabled="isLoading"
            color="primary"
            rounded
            dark
            @click="save"
          >
            Update Maintenance Log
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "@/axios";
export default {
  name: "MaintenanceLogEditPage",
  data() {
    return {
      form: {},
      isLoading: false,
      deviceItems: [],
      technicianItems: [],
      logTypeItems: [
        { text: 'Maintenance', value: 'maintenance' },
        { text: 'Calibration', value: 'calibration' },
        { text: 'Repair', value: 'repair' }
      ],
    };
  },
  computed: {
    errors() {
      return this.$store.getters['errors/getErrors'];
    },
  },
  mounted() {
    this.getMasters();
    this.getData();
  },
  methods: {
    async getMasters() {
      await axios
        .get(`masters?context=maintenance_log`)
        .then((masters) => {
          masters = masters.data;
          //Devices
          masters.devices.forEach((device) => {
            this.deviceItems.push({
              id: device.id,
              text: `${device.model_name} - ${device.serial_number}`,
              value: device.id,
            });
          });
          //Technicians
          masters.technicians.forEach((technician) => {
            this.technicianItems.push({
              id: technician.id,
              text: technician.first_name + ' ' + technician.last_name,
              value: technician.id,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          // redirect to Home Page
          // //window.location.href = "/auth/login";
        });
    },
    async getData() {
      this.isLoading = true;
      let encryptedId = this.$route.params.maintenanceLogId;
      axios
        .get(`/maintenance_logs/${encryptedId}`)
        .then((response) => {
          this.form = response.data.data;
          console.log(this.form);
          this.old_json = response.data.data;
        })
        .catch((error) => {
          // redirect to Home Page
          // //window.location.href = "/auth/login";
          console.error("Error fetching data:", error);
        });
      this.isLoading = false;
    },
    async save() {
      try {
        this.isLoading = true;
        await axios
          .patch(`/maintenance_logs/${this.$route.params.maintenanceLogId}`, this.form)
          .then(async () => {
            await this.saveUserTimestamp(this.old_json, this.form);
          })
          .catch((error) => {
            // redirect to Home Page
            // //window.location.href = "/auth/login";
            console.error("Error updating data:", error);
          });
        this.isLoading = false;
        this.$router.push("/maintenance_logs");
      } catch (e) {
        this.isLoading = false;
      }
    },
  },
};
</script>